// TODO 所有数学转介绍相关页面路由在此配置
// TODO 所有数学转介绍路由的path必须以 /referral/ 开头
// TODO 所有路由的name以及webpackChunkName必须以 referral 开头

export default [
  {
    path: '/referral',
    redirect: { name: 'referralActivityPage' }
  },
  {
    path: '/referral/activity',
    name: 'referralActivityPage',
    component: () => import(/* webpackChunkName: "referralActivityPage" */ '@/views/referral/activity.vue')
    // meta: {
    //   title: '活动页'
    // }
  },
  {
    path: '/referral/activityfour',
    name: 'referralActivityFourPage',
    component: () => import(/* webpackChunkName: "referralActivityPage" */ '@/views/referral/activityfour.vue')
  },
  {
    path: '/referral/recommend',
    name: 'accountRecommend',
    component: () => import(/* webpackChunkName: "accountRecommend" */ '@/views/referral/recommend.vue'),
    meta: {
      title: '我的推荐'
    }
  },
  {
    path: '/referral/rule',
    name: 'accountRecommend',
    component: () => import(/* webpackChunkName: "accountRecommend" */ '@/views/referral/rule.vue'),
    meta: {
      title: '奖励说明'
    }
  }
]
